import HeadComponent from "@/components/HeadComponent";
import JournalPostCover from "@/images/journalPostCover.png";
import { BiRadioCircle, BiRadioCircleMarked } from "react-icons/bi";
import Avatar from "react-avatar";
import { BsDot } from "react-icons/bs";
import Image from "next/image";
import { useEffect, useRef, useState, useContext } from "react";
import { callBackendApi } from "@/utils/common";
import Link from "next/link";
import PostCard from "@/components/Journal/PostCard";
import LikeBtn from "@/components/Journal/LikeBtn";
import ErrorStateImage from "@/images/stack empty state.svg";
import { OverlayTrigger } from "react-bootstrap";
import { AppContext } from "@/pages/_app";
import moment from "moment";
import Head from "next/head";


const JournalsPost = ({ postData, similarJournals, err }) => {
  const postBodyRef = useRef();
  const [headings, setHeadings] = useState([]);
  const [currentHeadingIndex, setCurrentHeadingIndex] = useState(null);
  const { loggedInUser, popoverLoginAlert } = useContext(AppContext);

  // create sidebar links of h3 heading from post body
  useEffect(() => {
    if (postData !== null) {
      // select current post body element
      const postBodyEl = postBodyRef.current;
      // find all h3 tag elements in post body element
      const allH3El = postBodyEl.querySelectorAll("h3");
      // create array of h3 tags
      let arrayHeadings = [];
      for (let i = 0; i < allH3El.length; i++) {
        const currentEl = allH3El[i];
        arrayHeadings.push(currentEl.innerText);
        currentEl.classList.add("lh-sm");
        currentEl.classList.add("fs-3");
        currentEl.setAttribute("id", i);
      }
      setHeadings([...arrayHeadings]);
    }
  }, [postData]);

  if (err.status) {
    return (
      <>
        <HeadComponent title={"Journal"} description={""} />
        <div className="m-auto d-flex justify-content-center align-items-center flex-column">
          <Image
            src={ErrorStateImage}
            width={700}
            height={300}
            className="mt-0"
          />
          <p className="text-muted mds-fs-md">
            {err.errMessage === "Journal Not Found"
              ? "Page Not Found"
              : "Something Went Wrong"}
          </p>
        </div>
      </>
    );
  }

  return (
    <>
      {postData.originalPostUrl && (
        <Head>
          <link rel="canonical" href={postData.originalPostUrl} />
        </Head>
      )}
      <HeadComponent
        title={
          postData.title.slice(0, 50) +
          (postData.title.length > 50 ? "..." : "")
        }
        description={
          "Hundreds of resources to help you level up your modern data stack and learn from the best"
        }
      />
      <>
        <div className="mds-bg-primary-muted">
          <div className="container d-none d-lg-block">
            <nav className="py-3">
              <ol className="breadcrumb mds-breadcrumb">
                <li className="breadcrumb-item">
                  <Link href="/journal">
                    <a>Journal</a>
                  </Link>
                </li>
                <li className="breadcrumb-item active">{postData.title}</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="mds-bg-primary-muted pb-5">
          <div className="container">
            <div className="d-flex flex-wrap justify-content-start gap-2 align-items-center">
              {postData.tags.map((item, index) => (
                <Link href={`/journal/tag/${item.slug}`} key={item.slug}>
                  <a>
                    <span
                      key={item.slug}
                      className="badge mds-bg-white mds-text-primary mds-fw-sm mds-border-muted rounded-pill mds-fs-4"
                    >
                      {item.tagName}
                    </span>
                  </a>
                </Link>
              ))}
            </div>
            <h1 className="m-0 py-3 mds-fw-xl mds-text-dark" id="postTitle">
              {postData.title}
            </h1>
            <div className="d-flex justify-content-start align-items-center gap-1">
              <Link href={`/u/${postData.userId.username}`}>
                <a className="d-flex align-items-center gap-2">
                  <span className="d-flex align-items-center">
                    {postData.userId.imageUrl ? (
                      <Image
                        layout="fixed"
                        className="border mds-border-primary-light rounded-circle"
                        src={postData.userId.imageUrl}
                        width={30}
                        height={30}
                      />
                    ) : (
                      <Avatar name={postData.userId.fullName} size={30} round />
                    )}
                  </span>
                  <span className="mds-text-dark">
                    {postData.userId.fullName}
                  </span>
                </a>
              </Link>
              <span>
                <BsDot />
              </span>
              <span className="mds-fw-sm mds-fs-sm">
                {moment(postData.createdAt).format("MMM DD, YYYY")}
              </span>
              <span>
                <BsDot />
              </span>
              <span className="mds-fw-sm mds-fs-sm">
                {String(postData.readTime) + " min read"}
              </span>
            </div>
          </div>
        </div>

        <div className="container py-5">
          <div className="row gx-lg-5 gy-lg-5">
            <div className="col-lg-4 pe-lg-5 ">
              <div className="sticky-top ">
                <div className="py-3 ps-3">
                  <OverlayTrigger
                    trigger={!loggedInUser && "click"}
                    placement="right"
                    rootClose
                    overlay={popoverLoginAlert}
                  >
                    <span>
                      <LikeBtn postData={postData} />
                    </span>
                  </OverlayTrigger>
                </div>
                <div className="d-none d-lg-block">
                  <h2 className="m-0 ps-3 pt-3 pb-4 mds-fw-lg fs-4 mds-text-dark ">
                    Jump To
                  </h2>
                  <div
                    id="list-example"
                    className="list-group list-group-flush sticky-top "
                    style={{ maxHeight: "70vh", overflow: "auto" }}
                  >
                    {headings.map((item, index) => (
                      <Link key={index} href={`#${index}`} replace>
                        <a
                          className={
                            "list-group-item list-group-item-action bg-transparent border-0 mds-border-radius" +
                            (currentHeadingIndex === index
                              ? " mds-bg-primary-light "
                              : "")
                          }
                          onClick={() => setCurrentHeadingIndex(index)}
                        >
                          <div className="d-flex justify-content-start align-items-start gap-2">
                            <span>
                              {currentHeadingIndex === index ? (
                                <BiRadioCircleMarked className="mds-text-primary fs-5" />
                              ) : (
                                <BiRadioCircle className="mds-text-primary fs-5" />
                              )}
                            </span>
                            <span className="mds-text-dark mds-fw-md flex-fill pb-2">
                              {item}
                            </span>
                          </div>
                        </a>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-8 ps-lg-5">
              <div className="w-100 pb-3">
                <img
                  src={postData.journalImageUrl || JournalPostCover}
                  style={{width: "100%"}}
                />
              </div>
              <div
                ref={postBodyRef}
                dangerouslySetInnerHTML={{ __html: postData.body }}
              ></div>
              {postData.originalPostUrl && (
                <div className="py-4">
                  <span className="text-muted">Originally posted </span>
                  <a
                    rel="noopener"
                    target={"_blank"}
                    className="mds-text-primary"
                    href={postData.originalPostUrl}
                  >
                    here
                  </a>
                </div>
              )}
            </div>
            {similarJournals.length > 0 ? (
              <div>
                <p className="mds-fs-lg mds-fw-lg">Similar Journal</p>
                <div className="row row-cols-1 row-cols-lg-3 g-4">
                  {similarJournals.map((item) => (
                    <div key={item.slug} className="col">
                      <PostCard postData={item} />
                    </div>
                  ))}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </>
    </>
  );
};

const PrimaryComponent = () => {
  return (
    <div className="py-3">
      <button className="btn mds-btn-primary">Contact us</button>
    </div>
  );
};

export default JournalsPost;

export const getServerSideProps = async (context) => {
  let postData = null;
  let similarJournals = null;
  let err = { status: false, errMessage: null };
  // get post slug from url
  const { slug } = context.query;
  // get post data from server
  try {
    const journalRes = await callBackendApi({
      method: "get",
      url: `/journal/${slug}`,
      context: context,
    });
    postData = journalRes.data.data;
  } catch (error) {
    err.status = true;
    if (error.response) {
      err.errMessage = error.response.data.error;
    }
  }

  try {
    const similarJournalsData = await callBackendApi({
      method: "get",
      url: "/journal/similar-journals",
      params: { slug: slug },
      context: context,
    });
    similarJournals = similarJournalsData.data.data;
  } catch (error) {
    console.log(error);
  }

  return {
    props: {
      similarJournals,
      postData,
      err,
    },
  };
};
